import {
  fetchTagsAction,
  unloadTagsAction,
} from "cortex/ui/src/fleet/redux-store/ui-state/tags/actions";

import { fetchOptionFactory } from "./fetchOptionFactory";

export const TagOptions = fetchOptionFactory(fetchTagsAction, unloadTagsAction);
